(() => {
  const data = document.getElementById('EcRecommendationsCopy');
  if (!data) return;
  const copy = JSON.parse(data.textContent);
  const setText = (node, value) => {
    value = value?.replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"');
    if (node && node.dataset.ecCopy !== value) { node.textContent = value; node.dataset.ecCopy = value; }
  };
  const overlayStyle = document.createElement('style');
  overlayStyle.textContent = 'html.ecRecommendationsOpen shopify-chat{visibility:hidden!important;pointer-events:none!important}';
  document.head.append(overlayStyle);
  let observedRoot;
  let observer;
  const decorate = root => {
    const campaign = root.querySelector('.pc-campaign-251483');
    const modal = campaign?.closest('#pc-modal-backdrop');
    document.documentElement.classList.toggle('ecRecommendationsOpen', Boolean(modal));
    if (!modal) return;
    modal.dataset.ecRecommendations = 'true';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', copy.title);
    if (!root.querySelector('#EcRecommendationsStyles')) {
      const style = document.createElement('style');
      style.id = 'EcRecommendationsStyles';
      style.textContent = `
        #pc-modal-backdrop[data-ec-recommendations] .modal-card{width:min(1000px,calc(100vw - 32px))!important;max-width:1000px!important;max-height:calc(100dvh - 40px)!important;margin:0!important;background:#faf8f5!important;border-radius:0!important;overflow:hidden!important;box-shadow:0 20px 80px #0003!important}
        #pc-modal-backdrop[data-ec-recommendations] .modal-content{max-height:calc(100dvh - 40px)!important;overflow-y:auto!important}
        #pc-modal-backdrop[data-ec-recommendations] .pop-content-blocks{padding:40px 32px 30px!important;background:#faf8f5!important;color:#242424!important;font-family:Arial,Helvetica,sans-serif!important;max-height:none!important;box-shadow:none!important}
        #pc-modal-backdrop[data-ec-recommendations] .block-content{padding:0!important}
        #pc-modal-backdrop[data-ec-recommendations] .text-block h1{font:400 34px/1.15 Arial,sans-serif!important;letter-spacing:-1px!important;color:#242424!important;margin:0 0 12px!important;text-align:left!important}
        #pc-modal-backdrop[data-ec-recommendations] .text-block p{font:14px/1.6 Arial,sans-serif!important;color:#625a52!important;text-align:left!important;margin:0 0 12px!important}
        #pc-modal-backdrop[data-ec-recommendations] .ec-recommend-eyebrow{display:block;font:600 10px/1.5 Arial,sans-serif!important;letter-spacing:1.5px!important;color:#a33b2c!important;text-align:left!important;margin:0 0 12px!important}
        #pc-modal-backdrop[data-ec-recommendations] .product-row{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:16px!important;align-items:stretch!important}
        #pc-modal-backdrop[data-ec-recommendations] .product{width:auto!important;min-width:0!important;margin:0!important;padding:0!important}
        #pc-modal-backdrop[data-ec-recommendations] .product-container{display:flex!important;flex-direction:column!important;height:100%!important;padding:0!important;gap:0!important}
        #pc-modal-backdrop[data-ec-recommendations] .product-container>div{display:flex!important;flex-direction:column!important;flex:1!important;min-width:0!important}
        #pc-modal-backdrop[data-ec-recommendations] .product img{width:100%!important;height:190px!important;object-fit:contain!important;display:block!important;background:#fff!important;margin:0 0 14px!important;padding:12px!important;box-sizing:border-box!important}
        #pc-modal-backdrop[data-ec-recommendations] .product p{font:500 14px/1.5 Arial,sans-serif!important;color:#242424!important;text-align:left!important;margin:0 0 10px!important;min-height:42px!important;display:-webkit-box!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:2!important;overflow:hidden!important}
        #pc-modal-backdrop[data-ec-recommendations] .product span{font:600 16px/1.5 Arial,sans-serif!important;color:#242424!important;text-align:left!important;margin-top:auto!important;margin-bottom:15px!important}
        #pc-modal-backdrop[data-ec-recommendations] .product button{background:#242424!important;color:#fff!important;border:0!important;border-radius:0!important;width:100%!important;min-height:46px!important;padding:10px 8px!important;white-space:normal!important;font:500 12px/1.4 Arial,sans-serif!important;margin:0!important}
        #pc-modal-backdrop[data-ec-recommendations] .product button:hover{background:#a33b2c!important}
        #pc-modal-backdrop[data-ec-recommendations] #pc-modal-close-button{top:8px!important;right:8px!important;transform:none!important;z-index:3!important}
        #pc-modal-backdrop[data-ec-recommendations] #pc-main-close-button{background:#faf8f5!important;border:0!important;border-radius:0!important;color:#242424!important;min-width:34px!important;min-height:34px!important;padding:7px!important}
        #pc-modal-backdrop[data-ec-recommendations] button:focus-visible,#pc-modal-backdrop[data-ec-recommendations] [role=button]:focus-visible{outline:2px solid #a33b2c!important;outline-offset:3px!important}
        @media(max-width:650px){#pc-modal-backdrop[data-ec-recommendations] .pop-content-blocks{padding:40px 20px 22px!important}#pc-modal-backdrop[data-ec-recommendations] .text-block h1{font-size:27px!important}#pc-modal-backdrop[data-ec-recommendations] .product-row{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:22px 12px!important}#pc-modal-backdrop[data-ec-recommendations] .product img{height:125px!important}#pc-modal-backdrop[data-ec-recommendations] .product p{font-size:12px!important;min-height:36px!important}#pc-modal-backdrop[data-ec-recommendations] .product span{font-size:15px!important}}
      `;
      root.append(style);
    }
    const text = campaign.querySelector('.text-block');
    setText(text?.querySelector('h1'), copy.title);
    setText(text?.querySelector('p'), copy.intro);
    if (text && !text.querySelector('.ec-recommend-eyebrow')) {
      const label = document.createElement('span');
      label.className = 'ec-recommend-eyebrow';
      label.textContent = copy.eyebrow;
      text.prepend(label);
    }
    campaign.querySelectorAll('.product').forEach((product, index) => {
      const title = product.querySelector('p');
      if (!title.dataset.ecOriginal) title.dataset.ecOriginal = title.textContent;
      // This campaign has four fixed products. Leave future selections intact.
      const known = ['Bandeau Minceur', 'Derma Roller Titanium', 'Masque Yeux Algues', 'Masque Yeux Or'];
      if (title.dataset.ecOriginal.startsWith(known[index] || '\u0000')) setText(title, copy.titles[index]);
      const image = product.querySelector('img');
      if (image) image.alt = title.textContent;
      const price = product.querySelector('span');
      if (price && !price.dataset.ecFormatted) {
        const amount = Number(price.textContent.replace(/[^0-9.,]/g, '').replace(',', '.'));
        if (Number.isFinite(amount) && amount > 0) {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:'EUR'}).format(amount);
          price.dataset.ecFormatted = 'true';
        }
      }
      const button = product.querySelector('button');
      if (button && /^(Ajouter au Panier|Add to cart|Añadir al carrito)$/i.test(button.textContent.trim())) setText(button, copy.button);
    });
    const close = modal.querySelector('#pc-main-close-button');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', copy.close);
      close.tabIndex = 0;
      if (!close.dataset.ecKeyboard) {
        close.dataset.ecKeyboard = 'true';
        close.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); close.click(); }
        });
      }
    }
  };
  const connect = () => {
    const root = document.getElementById('pop-convert-app')?.shadowRoot;
    if (!root || root === observedRoot) return;
    observedRoot = root;
    observer?.disconnect();
    observer = new MutationObserver(() => {
      observer.disconnect();
      decorate(root);
      observer.observe(root, {childList:true,subtree:true,characterData:true});
    });
    decorate(root);
    observer.observe(root, {childList:true,subtree:true,characterData:true});
  };
  connect();
  new MutationObserver(connect).observe(document.body, {childList:true,subtree:true});
  const discovery = setInterval(connect, 1000);
  setTimeout(() => clearInterval(discovery), 30000);
})();
